module.exports = __webpack_public_path__ + "static/img/active3.715b090e.png";